/* eslint-disable max-len */
import styled from 'styled-components';
import WithdrawsDarkIcon from '../../assets/images/withdraws-icon.svg';
import WithdrawsLightIcon from '../../assets/images/withdraws-icon-light.svg';

const WithdrawsIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${WithdrawsDarkIcon}") no-repeat left center`
      : `url("${WithdrawsLightIcon}") no-repeat left center`};
  background-size: 37px 33px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  height: 33px;
  width: 37px;
`;

export default WithdrawsIcon;
